export const environment = {
  production: true,
  apiUrl: "https://maintenance-dev.chapps.com/",
  environmentName: "Dev",
  accountSiteUrl: "https://account-dev.chapps.com/",
  zendeskUrl: "https://chappsnv.zendesk.com/hc",
  buildingManagerUrl: 'https://building-dev.chapps.com',
  roomsManagerUrl: 'https://dorm-dev.chapps.com/',
  rentalManagerUrl: 'https://rental-dev.chapps.com/',
};
